module.exports = __webpack_public_path__ + "img/img49.85760c04.svg";